var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Banner'),_c('BoxesArea'),_c('FeaturesArea'),_c('Features'),_c('Services'),_c('Team'),_c('Funfacts'),_c('Pricing'),_c('Feedback'),_c('Partner'),_c('Blog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }